export default __webpack_public_path__ + "static/article-lutein-noshtno-vijdane-5cab7d6d30b0c4a373260e317e4fa639.jpg";